import type { FaireProductEntity } from "../../entity_types/product";

export const p_jz4fnr42z5: FaireProductEntity = {
  token: "p_jz4fnr42z5",
  type: "product",
  name: "I ❤️ Candy Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/40d07eaa0b3e62ae2b27bba88fa22fe9885251e7ad51fce015a59d93127a2bcf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2c6084f619f38fa55fecf02b576a652233e0ec9fb1a9c57ee5be3f5d1921ae83.jpeg",
    "https://cdn.faire.com/fastly/269dd22bf9f66b22a2b48f7ca4525fc99c982392887e83b7c88224ac255a8b0f.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/94be49206be422c8d5ae0467fd7637fc8a574860b90f7fdfaa2157b1a452dfc1.jpeg",
    "https://cdn.faire.com/fastly/0cc8dca0ae4be586ea20c93746e7bc1d2d3cf837a72d0b30826ad8c516e71078.jpeg"
  ],
  priceDollars: 3.38,
  description: "There's nothing quite like the rush from eating waaaay too much candy. Get yourself a pair of these socks if you know what will ALWAYS make you smile. 🍬🍭😋\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:10.154Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
